"use client";

import { ReactNode } from "react";
import { AccordionTrigger } from "../ui/accordion";
import { gtmViewFaqItem } from "~/lib/client/gtm";

type Props = {
  title: string;
  text: string;
};

export default function FaqItemTrigger({ title, text }: Props): ReactNode {
  return (
    <AccordionTrigger onClick={() => gtmViewFaqItem(title, text)} iconInFront>
      <span className="w-full text-left">{title}</span>
    </AccordionTrigger>
  );
}
